module.exports = __webpack_public_path__ + "img/gith.6bb14737.png";